import 'swiper/swiper-bundle.min.css'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Carousel, Modal } from 'react-bootstrap'
import { SIZES } from 'src/styles/theme'
import Amplitude from 'src/utils/amplitudeHelper'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Scrollbar, A11y, Autoplay, Navigation, FreeMode } from 'swiper'
import { desktopAssets, fixedAssets } from 'src/containers/PreCache'
import { useDispatch, useSelector } from 'react-redux'
import { getSpeakers, setSpeaker } from 'src/ducks/speakers'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { Loader } from '../shared/Loader'
import Media from 'react-media'
import { IoClose } from 'react-icons/io5'

SwiperCore.use([Autoplay, Scrollbar, A11y, Navigation, FreeMode])

export const SpeakersProfileModal = ({ showModal, hideModal }) => {
  const dispatch = useDispatch()

  const { speakers, selectedSpeaker } = useSelector((state) => state.speakers)

  const [open, setOpen] = useState(false)

  const [loading, setLoading] = useState(true)
  const swiperRef = useRef()

  const onInit = (Swiper) => {
    swiperRef.current = Swiper
  }

  const handleMouseEnter = () => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.stop()
    }
  }
  const handleMouseLeave = () => {
    if (swiperRef.current) {
      swiperRef.current.autoplay.start()
    }
  }

  useEffect(() => {
    Amplitude.clickSpeaker()
    setOpen(true)
  }, [])

  useEffect(() => {
    if (speakers && speakers.length === 0) {
      dispatch(getSpeakers())
    }
    setLoading(false)
  }, [])

  const toggleModal = useCallback(() => {
    setOpen(false)
    dispatch(setSpeaker(null))
    setTimeout(hideModal, 900)
  }, [hideModal])

  const selectSpeakerHandler = (speaker) => {
    dispatch(setSpeaker(speaker))
  }
  const findSpeaker = (id) => {
    return speakers.find((speaker) => speaker.id === id)
  }

  const getSpeakerIndex = (id) => {
    return speakers.findIndex((speaker) => speaker.id === id)
  }

  const onNextHandler = (id) => {
    const speaker = findSpeaker(id)
    dispatch(setSpeaker(speaker))
  }

  const onPrevHandler = (id) => {
    const speaker = findSpeaker(id)
    dispatch(setSpeaker(speaker))
  }

  const onRightHandler = () => {
    if (swiperRef.current) {
      const swiper = swiperRef.current
      const totalSlides = swiper.slides.length
      let slideTo = swiper.activeIndex + 1

      if (slideTo >= totalSlides) {
        slideTo = 0
      }

      swiper.slideTo(slideTo, 1000)
    }
  }

  const onLeftHandler = () => {
    if (swiperRef.current) {
      const swiper = swiperRef.current
      const totalSlides = swiper.slides.length
      let slideTo = swiper.activeIndex - 2

      if (slideTo < 0) {
        slideTo = totalSlides - 1
      }

      swiper.slideTo(slideTo, 1000)
    }
  }

  return (
    <>
      <SharedModal open={open} show={showModal} onHide={toggleModal} size="lg" aria-labelledby="gallery-pdf-modal" centered animation={false}>
        <Modal.Header>
          <p className="file-description ">&nbsp;</p>
        </Modal.Header>
        <button className="btn c-button close-modal-btn d-none d-md-block" onClick={toggleModal}>
          <FaChevronRight />
        </button>
        <Modal.Body>
          {speakers.length > 0 && !selectedSpeaker ? (
            loading ? (
              <Loader />
            ) : (
              <>
                <div className="d-md-none custom-header d-flex flex-row justify-content-center align-items-center py-3">
                  <p className="mod-title text-center m-0">Speakers</p>
                  <div className="px-1 text-white" onClick={toggleModal} style={{ cursor: 'pointer' }}>
                    <IoClose size={30} />
                  </div>
                </div>
                {/* <div className="d-flex flex-row justify-content-center p-3 day">
              <button className="btn c-button" onClick={prevSpeakerHandler}><FaChevronLeft /></button>
              <button className="btn c-button" onClick={nextSpeakerHandler}><FaChevronRight /></button>
            </div> */}
                {!selectedSpeaker && (
                  <div className="d-none d-md-block speaker-header mb-5">
                    <img src={fixedAssets.speakerHeader} alt="Speaker Header" class="img-fluid" />
                  </div>
                )}
                <div className="s-carousel-container" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                  {/* <div className="s-carousel-container"> */}
                  <Swiper
                    speed={6000}
                    ref={swiperRef}
                    simulateTouch={true}
                    className="mySwiper"
                    modules={[Scrollbar, Autoplay, A11y, Navigation, FreeMode]}
                    slidesPerView={4}
                    watchSlidesProgress={false}
                    spaceBetween={16}
                    freeMode={true}
                    loop={true}
                    centeredSlides={true}
                    autoplay={{
                      delay: 1,
                      pauseOnMouseEnter: true,
                      disableOnInteraction: false,
                    }}
                    navigation={false}
                    breakpoints={{
                      // when window width is <= 999px
                      0: {
                        touchRatio: 10,
                        slidesPerView: 'auto',
                      },
                      768: {
                        touchRatio: 1,
                      },
                      1280: {
                        slidesPerView: 3,
                      },
                      1440: {
                        slidesPerView: 4,
                      },
                      2560: {
                        slidesPerView: 4,
                      },
                    }}
                    onInit={onInit}
                    scrollbar={{
                      draggable: true,
                    }}
                  >
                    {speakers.map((speaker) => (
                      <SwiperSlide key={speaker.id}>
                        <div className="speaker-wrapper" onClick={() => selectSpeakerHandler(speaker)}>
                          <img className="speaker-slide img-fluid" src={speaker.image} alt={speaker.name} />
                          <div className="overlay">
                            <p className="name">{speaker.name}</p>
                            <p className="position" dangerouslySetInnerHTML={{ __html: speaker.title }}></p>
                            <p dangerouslySetInnerHTML={{ __html: speaker.subtitle }}></p>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="speaker-carousel-controls">
                    <button className="btn c-button" onClick={onLeftHandler}>
                      <FaChevronLeft />
                    </button>
                    <button className="btn c-button" onClick={onRightHandler}>
                      <FaChevronRight />
                    </button>
                  </div>
                </div>
              </>
            )
          ) : (
            selectedSpeaker && (
              <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
                {(matches) =>
                  matches ? (
                    <>
                      {/* <div className="d-none d-mb-block speaker-header">
                        <img src={fixedAssets.speakerHeader} alt="Speaker Header" class="img-fluid" />
                      </div> */}
                      <p className="file-description d-none d-md-block">Speakers</p>
                      <SpeakerDetail>
                        <div className="speaker-controls">
                          <button className="btn c-button" onClick={() => onPrevHandler(selectedSpeaker.prev)} disabled={!selectedSpeaker.prev}>
                            <FaChevronLeft />
                          </button>
                          <button className="btn c-button" onClick={() => dispatch(setSpeaker(null))}>
                            All Speakers
                          </button>
                          <button className="btn c-button" onClick={() => onNextHandler(selectedSpeaker.next)} disabled={!selectedSpeaker.next}>
                            <FaChevronRight />
                          </button>
                        </div>
                        <div className="detail-wrapper">
                          <div className="info">
                            <h4 className="name">{selectedSpeaker.name}</h4>
                            <p className="title" dangerouslySetInnerHTML={{ __html: selectedSpeaker.title }}></p>
                            <p className="subtitle" dangerouslySetInnerHTML={{ __html: selectedSpeaker.subtitle }}></p>
                            <div className="divider"></div>
                            <p className="bio">{selectedSpeaker.bio}</p>
                          </div>
                          <div className="avatar-wrapper">
                            <div className="avatar">
                              <img src={selectedSpeaker.mobileAvatar} alt={selectedSpeaker.name} className="img-fluid" />
                            </div>
                          </div>
                        </div>
                      </SpeakerDetail>
                    </>
                  ) : (
                    <>
                      <div className="speaker-profile-controls">
                        <button className="btn c-button" onClick={() => onPrevHandler(selectedSpeaker.prev)} disabled={!selectedSpeaker.prev}>
                          <FaChevronLeft />
                        </button>
                        <button className="btn c-button py-2 px-4 font-bold" onClick={() => dispatch(setSpeaker(null))}>
                          All Speakers
                        </button>
                        <button className="btn c-button" onClick={() => onNextHandler(selectedSpeaker.next)} disabled={!selectedSpeaker.next}>
                          <FaChevronRight />
                        </button>
                      </div>
                      <Carousel
                        touch
                        wrap={false}
                        controls={false}
                        activeIndex={getSpeakerIndex(selectedSpeaker.id)}
                        indicators={false}
                        prevIcon={
                          <div className="zoom-btn" style={{ transform: 'rotate(180deg)', opacity: 1 }}>
                            &#10142;
                          </div>
                        }
                        nextIcon={
                          <div className="zoom-btn" style={{ opacity: 1 }}>
                            &#10142;
                          </div>
                        }
                      >
                        {speakers.map((speaker, index) => (
                          <Carousel.Item key={speaker.id}>
                            <div className="d-flex justify-content-center items-align-center">
                              <img className="img-fluid" src={speaker.desktopBio} alt={`Speaker ${index + 1}`} style={{ maxWidth: '99%' }} />{' '}
                            </div>
                          </Carousel.Item>
                        ))}
                      </Carousel>
                    </>
                  )
                }
              </Media>
            )
          )}
        </Modal.Body>
      </SharedModal>
    </>
  )
}

const SpeakerDetail = styled.div`
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8.25px);
  .detail-wrapper {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    color: #fff;
    padding: 1rem;
    align-items: center;

    div:first-child {
      order: 2;
    }
    div:last-child {
      order: 1;
    }
  }



  .divider {
    height: 5px;
    width: 90%;
    background: var(--light-blue-900);
    margin: 1rem 0;
  }

  .name {
    color: var(--yellow);
    font-size: 20px;
  }

  .title {
    font-style: italic;
  }
  .title,
  .subtitle {
    font-size: 16px;
    color: #fff;
    margin: 0;
  }

  .bio {
    font-size: 16px;
    text-align: justify;
  }

  .flex-1 {
    flex: 1 0 auto;
  }

  .avatar {
    border: 3px solid #cacacc;
    width: 223px;
    height: 222px;
    overflow: hidden;
    border-radius: 12rem;
  }

  .speaker-controls {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
    margin-top: 1rem;
    button {
      color: var(--light-blue-900) !important;
      font-weight: 500;
    }
    padding: 1rem 0;

    button:nth-child(2) {
      padding: 0.6rem 2rem;
    }
  }

  @media (min-width: 768px) {
    .detail-wrapper {
      flex-direction: row;
      gap: 5rem;
      min-height: 600px;
      div:first-child {
        order: 1;
      }
      div:last-child {
        order: 2;
      }
    }

    .avatar {
      width: 350px;
      height: 350px;
    }
  }
`
const SharedModal = styled(Modal)`
  left: ${(props) => (props.open ? '0' : '100%')};
  transition: 1s !important;
  scrollbar-width: thin;
  .modal-dialog {
    width: 90%;
    max-width: unset;
    margin: 0 !important;
    margin-left: auto !important;
    border-radius: 0;

    @media (max-width: ${SIZES.mobileBreakpoint}) {
      width: 100%;
    }
  }
  .mod-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #fff;
    flex: 1 1 0;
  }
  .modal-content {
    border-radius: 0;
    width: 100%;
    min-height: 100vh;
    max-width: 100%;
    background: rgba(17, 24, 39, 0.90);
    
  }

  .close-modal-btn {
    position: absolute;
    left: -20px;
    z-index: 99999;
    bottom: 50%;
  }

  .speaker-carousel-controls {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    margin: 1rem 0;
    justify-content: center;
    padding-inline: 1rem;

    @media (min-width: 1280px) {
      justify-content: space-between;
      margin-top: 1%;
      z-index: 1;
      position: relative;

      button {
        padding: 0.7rem 1rem;
      }
    }
  }

  .speaker-profile-controls {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: center;
    margin: 1rem 0;
  }

  .s-carousel-container {
  }

  .swiper-wrapper {
    height: auto;
    width: 300px;
    -webkit-transition-timing-function: linear !important;
    -o-transition-timing-function: linear !important;
    transition-timing-function: linear !important;
  }

  .swiper-slide {
  max-width: 346px;
  max-height: 497px;
  }

  .speaker-wrapper {
    position: relative;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    max-height: 497px;


    img {
      width: 100%;
      
    }

    .overlay {
      position: absolute;
      z-index: 1;
      bottom: 0;
      padding: 1rem;
      background: rgba(0, 0, 0, 0.7);
      color: #fff;
      transition: all 0.2s ease-in-out;
      width: 100%;
      min-height: 150px;
      text-align: center;

      .name {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 6px;
      }

      p {
        font-size: 13px;
        margin: 0;
      }

      .position {
        font-style: italic;
      }

      .override {
        font-size: 13px !important;
      }
    }

    @media (min-width: 768px) {
      &:hover .overlay {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: end;
        background: rgba(2, 132, 199, 0.75);
      }

      .overlay {
        min-height: 112px;
        .name {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 6px;
        }

        p {
          font-size: 11px;
          margin: 0;
        }

        .position {
          font-size: 11px;
          font-style: italic;
        }
      }
    }
  }

  .modal-header {
    padding: 12px;
    border: none;
    display: block;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 0;
    position: sticky;
    top: 0;
    z-index: 1000;

    button.close {
      opacity: 1;
      padding: 4px auto !important;
      z-index: 100;
      position: absolute;
      top: 5px;
      right: 20px;
      span {
        font-weight: 400;
        font-size: 34px;
        color: #fff;
        text-shadow: none;
      }
    }
  }
  p.file-description {
    padding: 8px auto;
    font-size: 16px;
    margin: 0;
    color: #fff;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
  }

  .modal-body {
    padding: 0;
    width: 100%;
    max-width: 100%;
  }
  .flex-container {
    display: flex;
    justify-content: center;
  }
  .buttons {
    position: absolute;
    top: 5px;
    left: 5px;
    display: flex;
    z-index: 1000;
  }

  header {
    display: none;
    justify-content: center;
    flex-wrap: wrap;
    padding-bottom: 0.5rem;
  }
  header {
    .active {
      color: #f8c605;
      border-bottom: 2px solid #f8c605;
    }
  }
  .appear {
    opacity: 0;
    animation: appear 500ms forwards;
  }
  ${SIZES.mobile} {
    header {
      display: flex;
      position: sticky;
      top: 49.5px;
      z-index: 1000;
      background: rgba(0, 0, 0, 0.55);
    }
    .modal-dialog {
      max-width: 100%;
    }
    .modal-header {
      padding: 8px;
      display: flex;
      align-items: center;
      button.close {
        position: static;
        margin: 0;
        padding: 0;
      }
    }
    .modal-body {
      position: static;
      overflow: initial;
    }
    p.file-description {
      font-size: 14px;
      text-align: left;
    }
    .modal-content {
      background: rgba(0, 0, 0, 0.8);
      backdrop-filter: blur(8.25px);
    }
    .buttons {
      position: static;
    }
    .zoom-btn {
      margin: 0 2px;
      width: 30px;
      height: 30px;
    }
  }
`
